import moment from "moment";
import $ from "jquery";
import "fullcalendar";
import "fullcalendar-scheduler";
import { ShowStatusMessage } from "./status-message";
/**
 * @Description: Class to handle requests for appt bookings.
 * @Author: Sudharaka
 * @Date: 8/20/2018
 **/
export class ApptBookingRequests {
    constructor(day, jobCode, longitude, latitude, orderNumber, orderId) {
        this.day = day;
        this.jobCode = jobCode;
        this.longitude = longitude;
        this.latitude = latitude;
        this.orderNumber = orderNumber;
        this.orderId = orderId;
    }
    returnApptBookings(calendar, timeline = false, searchDate = null, startEndTimes = null, slot_group = null) {
        const calendarView = calendar.fullCalendar('getView');
        let startDate, endDate;
        if (calendarView) {
            startDate = calendarView.intervalStart;
            endDate = calendarView.intervalEnd;
        }
        else {
            startDate = moment(this.day);
            endDate = startDate.add(31, "days");
        }
        let requestPromise = new Promise((resolve, reject) => {
            let calEvents = [];
            $.ajax({
                type: "POST",
                url: "/sl3/rest/bookings/appointments/query_by_id",
                data: JSON.stringify({
                    start_time: startDate.format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"),
                    end_time: endDate.format("YYYY-MM-DD[T]HH:mm:ss.SSSZ"),
                    /*order_data: {
                      job_code: this.jobCode,
                      longitude: this.longitude,
                      latitude: this.latitude,
                      custom_properties: [{ name: "query_modes", value: "SLOT,AVAILABILITY" }]
                    },*/
                    order_id: this.orderId,
                    include_full_slots: false //Not sure what is this used for, this is placeholder for now.
                    /*time_slots: startEndTimes*/
                }),
                contentType: "application/json",
                dataType: "json",
                cache: false,
                context: this,
                success: function (rsp) {
                    if (!rsp.error) {
                        $.ajax({
                            type: "GET",
                            url: "/sl3/rest/bookings/appointments/by_order_number/" + this.orderNumber,
                            contentType: "application/json",
                            dataType: "json",
                            cache: false,
                            success: function (orderEvent) {
                                if (!rsp.error) {
                                    putCalendarEvents(rsp, orderEvent);
                                }
                                else if (rsp.availabilities && rsp.error.reason.includes("No booking found for order_number")) {
                                    putCalendarEvents(rsp, null, slot_group);
                                }
                                else {
                                    new ShowStatusMessage().showStatusMsg(rsp.error.reason, 1, null, null);
                                }
                            },
                            error: function (err) {
                                if (err.responseText.includes("No booking found for order_number")) {
                                    putCalendarEvents(rsp, null, slot_group);
                                }
                            }
                        });
                    }
                    else {
                        new ShowStatusMessage().showStatusMsg(rsp.error.reason, 1, null, null);
                    }
                },
                error: function (err) {
                    if (err.responseText.includes("Not enough data was supplied to determine filter")) {
                        new ShowStatusMessage().showStatusMsg("Not enough data was supplied to determine filter.", 1, null, null);
                        reject();
                    }
                }
            });
            function putCalendarEvents(rsp, orderEvent = null, slot_group = null) {
                let availabilitiesArray = rsp.availabilities;
                if (orderEvent != null) {
                    availabilitiesArray.push({ distance_km: -1, availability: orderEvent });
                }
                for (let bookingQueryElement of availabilitiesArray) {
                    let availability = bookingQueryElement.availability;
                    if (availability.max_appointments != availability.appointments_booked ||
                        availability.id == 0 ||
                        bookingQueryElement.distance_km == -1) {
                        if (slot_group != null) {
                            if (availability.slot.slot_group != null && availability.slot.slot_group.name == slot_group)
                                addCalEvents(bookingQueryElement.distance_km, availability);
                            else
                                continue;
                        }
                        else {
                            addCalEvents(bookingQueryElement.distance_km, availability);
                        }
                    }
                }
                calendar.fullCalendar("removeEvents");
                calendar.fullCalendar("removeEventSources");
                calendar.fullCalendar("addEventSource", calEvents);
                resolve();
            }
            function addCalEvents(distance_km, availability) {
                var name = availability.slot.name;
                var year = timeline ? searchDate.format("YYYY") : availability.year;
                var month = timeline
                    ? searchDate.format("MM")
                    : availability.month <= 9
                        ? "0" + availability.month
                        : availability.month;
                var day = timeline
                    ? searchDate.format("DD")
                    : availability.day <= 9
                        ? "0" + availability.day
                        : availability.day;
                var timeStart = (availability.slot.hour_start <= 9 ? "0" + availability.slot.hour_start : availability.slot.hour_start) +
                    ":" +
                    (availability.slot.min_start === 0 ? "00" : availability.slot.min_start);
                var timeEnd = (availability.slot.hour_end <= 9 ? "0" + availability.slot.hour_end : availability.slot.hour_end) +
                    ":" +
                    (availability.slot.min_end === 0 ? "00" : availability.slot.min_end);
                var timeSlot = timeStart + "-" + timeEnd;
                let color;
                if (distance_km == -1) {
                    color = "black";
                }
                if (distance_km > 10) {
                    color = "red";
                }
                else if (distance_km > 5) {
                    color = "yellow";
                }
                else if (distance_km > 0) {
                    color = "green";
                }
                let distance_miles = Math.round(distance_km * 0.62137);
                let calEvt;
                if (timeline) {
                    calEvt = {
                        title: availability.id == 0 ? timeSlot + " " + distance_miles + " miles" : timeSlot + " " + name,
                        start: moment(year + "-" + month + "-" + day + "T" + timeStart + ":00"),
                        end: moment(year + "-" + month + "-" + day + "T" + timeEnd + ":00"),
                        name: name,
                        color: color,
                        resourceId: year + "-" + month + "-" + day,
                        objId: availability.id,
                        slotId: availability.id,
                        max: availability.max_appointments,
                        current: availability.appointments_booked
                    };
                }
                else {
                    calEvt = {
                        name: name,
                        title: availability.id == 0 ? timeSlot + " " + distance_miles + " miles" : timeSlot + " " + name,
                        start: moment(year + "-" + month + "-" + day + " " + timeStart + ":00"),
                        end: moment(year + "-" + month + "-" + day + "T" + timeEnd + ":00"),
                        objId: availability.id,
                        slotId: availability.id,
                        max: availability.max_appointments,
                        current: availability.appointments_booked,
                        color: color
                    };
                }
                calEvents.push(calEvt);
            } // addCalEvents
        });
        return requestPromise;
    }
}
